import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <p>© 2025 - Dennis Sharon Cheruvathoor - Boston, MA</p>
            </div>
        </footer>
    );
};

export default Footer;
